/**
 * Список тем
 * @return Promise
 */
const themeList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Объект одной темы
 * data.id - обязательный параметр
 * @return Promise
 */
const themeGet = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Добавление темы
 * @return Promise
 */
const createTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/create",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Дублирование темы
 * @return Promise
 */
const copyTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/copy",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Редактирование темы
 * @return Promise
 */
const editTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Удаление темы
 * @return Promise
 */
const deleteTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Восстановление темы
 * @return Promise
 */
const recoveryTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/theme/recovery",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export {
  recoveryTheme,
  deleteTheme,
  editTheme,
  createTheme,
  copyTheme,
  themeGet,
  themeList
};
